/**
 * Validadores del formulario de rangos de precios (RangoForm)
 */

/**
 * Comprueba que un campo de texto tenga contenido tras recortar espacios.
 * Usado para transportista, isla y rango de códigos postales.
 */
export const esCampoRequerido = (valor) => String(valor ?? "").trim().length > 0;

/**
 * Comprueba que un precio sea un número válido mayor o igual a 0.
 * Un valor vacío también es inválido: no hay un mensaje "obligatorio" aparte
 * para precio bulto/palet, un vacío simplemente no es un número válido.
 */
export const esPrecioValido = (valor) => {
    const texto = String(valor ?? "").trim();
    if (!texto) return false;

    const numero = Number(texto);
    return Number.isFinite(numero) && numero >= 0;
};
